import React, {useEffect, useRef, useState} from 'react';
import {mrbgStore, setActivePopups, setSettingsForm} from './mrbgRedux/index.js';
import humanStyle from '../../static/css/MP_human.module.css'

function MrbgHumanDefineArea(){

	const
		svgList = useRef(null),
		[activePopup,setActivePopup] = useState(mrbgStore.getState().activePopups.fullPU),
		[activeForms,setActiveForms] = useState(mrbgStore.getState().activeForms),
		[formID,setFormID] = useState(undefined),
		[svgAreaInfo,setSvgAreaInfo] = useState(mrbgStore.getState().mrbgVars.svgAreaInfo),
		[cls,setCls] = useState([humanStyle.hide]),
		[value, setValue] = useState(null),
		[gender,setGender] = useState('خانم'),
		[angle,setAngle] = useState({'خانم':0,'آقا':0}),
		[width,setWidth] = useState(null);

	function clickArea( val ){
		var fs = JSON.parse(JSON.stringify(mrbgStore.getState().formsSettings[formID]));
		if( value==val )
			delete fs.hideInp.svgAreaName;
		else
			fs.hideInp = {
				...fs.hideInp,
				svgAreaName: val
			};
		mrbgStore.dispatch(setSettingsForm({[formID]:fs}))
	}
	function hidePopUp( e ){
		if(
			!document.getElementById( humanStyle.areaDefineFrame ).contains(e.target) &&
			!document.getElementByDataID(formID).querySelector('div[name="gender"]').contains(e.target)
		)
			setCls( [...cls,humanStyle.hide].arrayUnique() )
	}

	useEffect(() => {
		const observer = new ResizeObserver(entries => {
			for( let entry of entries )
				setWidth(entry.contentRect.width);
		});

		if( svgList.current ){
			observer.observe(svgList.current);
		}

		return () => observer.disconnect();
	}, [activePopup]);
	useEffect(()=>{
		if( activeForms?.includes('areFrame') )
			setFormID('are');
		else if( activeForms?.includes('areUpdFrame') )
			setFormID('areUpd');
		else
			setFormID(undefined)
	},[activeForms])
	useEffect(() => {
		if(formID){
			mrbgStore.dispatch(setActivePopups({fullPU:'areaDefineFrame'}));
			setCls( [...cls,humanStyle.active].arrayUnique() );
			const unsubscribe = mrbgStore.subscribe(()=>{
				setValue ( mrbgStore.getState().formsSettings[formID]?.hideInp.svgAreaName||undefined );
				setGender( mrbgStore.getState().formsSettings[formID]?.sundryField?.gender )
			})
			return () =>unsubscribe();
		}
		else
			setCls( [humanStyle.hide] );
	}, [formID]);
	useEffect(()=>{
		if( !cls.includes(humanStyle.hide) ){
			document.addEventListener('click', hidePopUp);
			return document.removeEventListener('click', hidePopUp);
		}
	},[cls])
	useEffect(()=>{
		const unsubscribe = mrbgStore.subscribe(()=>{
			setActivePopup( mrbgStore.getState().activePopups.fullPU );
			setSvgAreaInfo( mrbgStore.getState().mrbgVars.svgAreaInfo );
			setActiveForms( mrbgStore.getState().activeForms );
		})
		return () =>unsubscribe();
	},[]);

	if( activePopup!=='areaDefineFrame' )
		return <div id={humanStyle.areaDefineFrame}></div>

	else{
		return (
			<div id={humanStyle.areaDefineFrame} className={cls.join(' ')}>
				<i id={humanStyle.arrow} className="fa-solid fa-chevron-left" onClick={()=>setCls([...cls].toggleItem(humanStyle.hide).arrayUnique())}></i>
				<div className={humanStyle.svgListFrame}>
					<i className="fa-solid fa-caret-right" onClick={() => setAngle({...angle,[gender]:angle[gender]+120})}></i>
					<ul className={humanStyle.svgList} ref={svgList}>
						{
							Object.keys(svgAreaInfo).map((gnd,i)=>{
								return(
									<li style={{transform:`translatex(${gender==='آقا'? 100: 0}%)`}} key={i}>
										<div style={{transform:`translateZ(${Math.ceil(width/(-2*Math.tan(Math.PI/3)))}px) rotateY(${angle[gnd]}deg)`}}>
											{
												Object.keys(svgAreaInfo[gnd]).map((side,j)=>{
													return(
														<svg id={humanStyle.wonamFront} viewBox={`0 0 ${gender=='خانم'? '200 620':'240 710'}`} xmlns="http://www.w3.org/2000/svg" key={j} style={{transform:`rotateY(${j*-360/3}deg) translateZ(${Math.floor(width/(2*Math.tan(Math.PI/3)))}px)`}}>
															{
																svgAreaInfo[gnd][side].map((info,k)=>{
																	if( ['selectable','bikini'].includes(info.className) )
																		return (
																			<g key={k}>
																				<path className={`${humanStyle[info.className]} ${(value===info.svgAreaName && gender===info.gender)? humanStyle.selected: ''}`} d={info.d} pathLength="1" onClick={() => clickArea(info.svgAreaName)}></path>
																				{info.wrinkleD && <path className={humanStyle.wrinkleD} d={info.wrinkleD} onClick={() => clickArea(info.svgAreaName)}></path>}
																				<title>{info.name}</title>
																			</g>
																		)
																	else
																		return <path className={humanStyle[info.className]} d={info.d} key={k}></path>
																})
															}
														</svg>
													)
												})
											}
										</div>
									</li>
								)
							})
						}
					</ul>
					<i className="fa-solid fa-caret-left" onClick={() => setAngle({...angle,[gender]:angle[gender]-120})}></i>
				</div>
			</div>
		)
	}
}

export default MrbgHumanDefineArea;